import { $delegate, $find, $is, $on, $qs, $toggleClass, $trigger } from 'fxdom/es';

import { each, go, identity, omit } from 'fxjs/es';
import querystring from 'querystring';
import { ComponentsHeaderF } from '../../../../../Components/Header/F/Function/module/ComponentsHeaderF.js';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF.js';

const active_class = 'header-menu__anchor--active';

export const delegateMainFrame = (frame_el$) =>
  go(
    frame_el$,
    MShopUtilF.isMobile()
      ? identity
      : $on('keydown', (e) => {
          const keyCode = e.keyCode || e.which;
          if (keyCode == 9 && e.shiftKey) {
            const [first$] = ComponentsHeaderF.findFocusElement(e.currentTarget);
            if (!$is(':focus', first$)) return;
            e.originalEvent.preventDefault();
            const [, lastFocusEl] = ComponentsHeaderF.findFocusElement($qs('.bottom-tab-bar'));
            lastFocusEl.focus();
          }
        }),
    $delegate('click', '[data-selector="header-category"]', ({ currentTarget: target_el, originalEvent }) => {
      const already_active_el = $qs(`.header-menu__anchor.${active_class}`);
      if (already_active_el == target_el) {
        originalEvent.preventDefault();
        return MShopUtilF.moveScrollToTop();
      }

      if (!MShopUtilF.isApp()) return;

      originalEvent.preventDefault();

      const idx = parseInt(target_el.dataset.index);
      const search_str = querystring.stringify(omit(['page'], querystring.parse(target_el.search.slice(1))));
      const selectedTabUri =
        target_el.pathname.replace(new RegExp(`/${T.lang}`), '') + (search_str ? `?${search_str}` : '');

      already_active_el.href = location.pathname + location.search;
      MuiF.extendHistoryState(null, null, `/${T.lang}` + selectedTabUri, true);
      MShopUtilF.postMessage({ selectedTabUri });
      each($toggleClass(active_class), [already_active_el, target_el]);

      $trigger('click', $find(`.tab_buttons button:nth-child(${idx + 1})`, frame_el$));
    }),
  );
